import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SubHeader from './components/SubHeader';

const BookingsReport = () => {

  const navigate = useNavigate();
  const pickedDate = useSelector(state => state.pickedDateReducer.pickedDate);

  // Modal state
  const [clientModalOpen, setClientModalOpen] = useState(false);
  const [bookingId, setBookingId] = useState('');
  const [bookingDetailsData, setBookingDetailsData] = useState({});

  // Timeline state
  const [items, setItems] = useState([]);
  const [timelineState, setTimelineState] = useState({
    visibleTimeStart: null,
    visibleTimeEnd: null,
    today: null,
    endToday: null,
  });

  const loadedRangeRef = useRef({ start: null, end: null });

  const handleItemClick = (itemId, e, time) => {

  }

  return (
    <>
      <SubHeader setTimelineState={setTimelineState} />
    </>
  );
};

export default BookingsReport;
